export function beforeSave(record) {
  const newRecord = {
    ...record,
    enabled: record.configData.enabled,
    sendForSku: record.configData.sendForSku,
    sendForDescription: record.configData.sendForDescription,
  };

  delete newRecord.configData;

  return newRecord;
}
